onLoad(($) => {
  const nodes = $('.input--new-percent');

  if (!nodes.length) return;
    $('#ticket_loan_formatted_comission_tax').val($('#ticket_loan_formatted_comission_tax').val().toString().replace(/\./g, ','))
    $('#ticket_loan_formatted_remuneration_tax').val($('#ticket_loan_formatted_remuneration_tax').val().toString().replace(/\./g, ','))
});
